import axiosClient from "./axiosClient";

// Both calls are best-effort analytics; a failure must never affect the visitor's experience.
export async function recordVisitorSession(info) {
  try {
    await axiosClient.post("/Visitors/session", info);
  } catch {
    // ignore
  }
}

export async function recordPageView(path, referrer) {
  try {
    await axiosClient.post("/Visitors/page-view", { path, referrer });
  } catch {
    // ignore
  }
}
